import { render, staticRenderFns } from "./TableConsult.vue?vue&type=template&id=1b1542aa"
import script from "./TableConsult.vue?vue&type=script&lang=js"
export * from "./TableConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports